class ViewerInfoContract {
	constructor(repFirstName, repLastName, last4SsnTin, primaryRepCode) {
		this.repFirstName = repFirstName;
		this.repLastName = repLastName;
		this.last4SsnTin = last4SsnTin;
		this.primaryRepCode = primaryRepCode;
	}
}

export default ViewerInfoContract;